"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHumanReadableDuration = toHumanReadableDuration;
function toHumanReadableDuration(milliseconds) {
    var seconds = Math.floor(milliseconds / 1000);
    if (seconds < 60) {
        return "".concat(Math.round(milliseconds / 1000), " seconds");
    }
    else if (seconds < 3600) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(minutes, " minutes ").concat(remainingSeconds, " seconds");
    }
    else if (seconds < 86400) {
        var hours = Math.floor(seconds / 3600);
        var remainingMinutes = Math.floor((seconds % 3600) / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(hours, " hours ").concat(remainingMinutes, " minutes ").concat(remainingSeconds, " seconds");
    }
    else {
        var days = Math.floor(seconds / 86400);
        var remainingHours = Math.floor((seconds % 86400) / 3600);
        var remainingMinutes = Math.floor((seconds % 3600) / 60);
        return "".concat(days, " days ").concat(remainingHours, " hours ").concat(remainingMinutes, " minutes");
    }
}
//# sourceMappingURL=toHumanReadableDuration.js.map